import { a11yLight, CodeBlock } from "react-code-blocks";
import { CodeWrapper } from "./styled";
import { FC } from "react";

interface CodeProps {
  json?: Record<string, unknown> | null;
}

export const Code: FC<CodeProps> = ({ json }) => {
  if (!json) return null;

  return (
    <CodeWrapper>
      <CodeBlock
        language="json"
        showLineNumbers
        theme={a11yLight}
        text={JSON.stringify(json, null, 2)}
      />
    </CodeWrapper>
  );
};
